<!--学校统计看板  -->
<template>
    <div class="stat-container">
        <!--左栏-->
        <div class="l-stat-container">
            <div class="org-container">
                <div class="org-logo-container">
                    <img class="org-logo" alt="" :src="userInfo.avatar + '?_=' + Date.now()" >
                </div>
                <div class="school-name-container">{{orgInfo.orgName}}</div>
                <div class="org-name-container">{{orgInfo.parentOrgName}}</div>
            </div>
            <div class="menu-container">
                <div @click="changeItem('1')" :class="activeItem==='1'?'menu-item menu-active':'menu-item'">教师均衡发展驾驶舱</div>
                <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">课堂研究驾驶舱</div>
                <!--                <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">教研资产管理</div>-->
            </div>
        </div>
        <!--右栏-->
        <div class="r-stat-container">
            <div class="school-info-container">
                <div class="l-school-info-container"></div>
                <div class="r-school-info-container">
                    <div class="r-school-info-container-child1">{{orgInfo.orgName}}</div>
                    <div class="r-school-info-container-child2">{{itemName}}</div>
                </div>
                <div class="l-school-info-container">
                    <el-select @change="orgChange" v-if="orgList&&orgList.length>1"
                               v-model="orgId"
                               filterable
                               style="width: 140px;margin-top: 20px"
                               placeholder="请选择">
                        <el-option v-for="item in orgList" :key="item.orgId" :label="item.orgName"
                                   :value="item.orgId" />
                    </el-select>
                </div>
            </div>
            <!-- 数据看板-教师均衡发展驾驶舱 -->
            <div class="dashboard-container" v-if="activeItem==='1'">
                <div class="item1-l-content-container">
                    <div class="tea-data-container" v-loading="loading1">
                        <div class="data-title-container">
                            <div class="title-container1"></div>
                            <div class="title-container2">教师概况</div>
                            <div class="title-container3">{{timestampDate(currentTime)}}更新</div>
                        </div>
                        <div class="tea-data-info-container">
                            <div class="tea-data-item">
                                <div class="tea-data-item-child1">{{teaData.teacherCount}}</div>
                                <div class="tea-data-item-child2">教师数量</div>
                            </div>
                            <div class="tea-data-item">
                                <div class="tea-data-item-child1">{{teaData.rankTeacherCount}}</div>
                                <div class="tea-data-item-child2">高职称教师数量</div>
                            </div>
                            <div class="tea-data-item">
                                <div class="tea-data-item-child1">{{teaData.backboneTeacherCount}}</div>
                                <div class="tea-data-item-child2">骨干教师数量</div>
                            </div>
                            <div class="tea-data-item">
                                <div class="tea-data-item-child1">{{teaData.eduTeacherCount}}</div>
                                <div class="tea-data-item-child2">高学历教师数量</div>
                            </div>
                            <div class="tea-data-item">
                                <div class="tea-data-item-child1">{{teaData.manTeacherCount}}</div>
                                <div class="tea-data-item-child2">男教师数量</div>
                            </div>
                            <div class="tea-data-item">
                                <div class="tea-data-item-child1">{{teaData.womanTeacherCount}}</div>
                                <div class="tea-data-item-child2">女教师数量</div>
                            </div>
                        </div>
                        <div class="tea-echart-container">
                            <div class="tea-echart-item-container1">
                                <div class="data-dashboard-title">
                                    <div class="data-title">教师性别分布</div>
                                </div>
                                <div class="tea-echart-item">
                                    <div class="tea-echart-item-l">
                                        <area-tea-xb-echart :man-count="teaData.manTeacherCount" :woman-count="teaData.womanTeacherCount"/>
                                    </div>
                                    <div class="tea-echart-item-r">
                                        <div class="item_container1">
                                            <div class="item_01">
                                                <div class="item_color1"></div>
                                                <div class="item_info">
                                                    <div class="item_info_c1">男教师</div>
                                                    <div class="item_info_c2">{{teaData.manTeacherRate}}%</div>
                                                </div>
                                            </div>
                                            <div class="item_01">
                                                <div class="item_color2"></div>
                                                <div class="item_info">
                                                    <div class="item_info_c1">女教师</div>
                                                    <div class="item_info_c2">{{100-teaData.manTeacherRate}}%</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tea-echart-item-container1">
                                <div class="data-dashboard-title">
                                    <div class="data-title">教师学历分布</div>
                                </div>
                                <div class="tea-echart-item">
                                    <div class="tea-echart-item-l">
                                        <area-tea-xl-echart :tea-count1="teaData.ssTeacherCount"
                                                            :tea-count2="teaData.bkTeacherCount"
                                                            :tea-count3="teaData.zkTeacherCount" />
                                    </div>
                                    <div class="tea-echart-item-r">
                                        <div class="item_container2">
                                            <div class="item_01">
                                                <div class="item_color1"></div>
                                                <div class="item_info">
                                                    <div class="item_info_c1">硕士及以上</div>
                                                    <div class="item_info_c2">{{teaData.ssTeacherRate}}%</div>
                                                </div>
                                            </div>
                                            <div class="item_01">
                                                <div class="item_color2"></div>
                                                <div class="item_info">
                                                    <div class="item_info_c1">大学本科</div>
                                                    <div class="item_info_c2">{{teaData.bkTeacherRate}}%</div>
                                                </div>
                                            </div>
                                            <div class="item_01">
                                                <div class="item_color3"></div>
                                                <div class="item_info">
                                                    <div class="item_info_c1">专科及其他</div>
                                                    <div class="item_info_c2">{{teaData.zkTeacherRate}}%</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tea-echart-item-container2">
                                <div class="data-dashboard-title">
                                    <div class="data-title">教师职称分布</div>
                                </div>
                                <div class="tea-echart-item">
                                    <div class="tea-echart-item-l">
                                        <area-tea-zc-echart :tea-zc-count1="teaData.gjRankTeacherCount"
                                                            :tea-zc-count2="teaData.yjRankTeacherCount"
                                                            :tea-zc-count3="teaData.ejRankTeacherCount" />
                                    </div>
                                    <div class="tea-echart-item-r">
                                        <div class="item_container2">
                                            <div class="item_01">
                                                <div class="item_color1"></div>
                                                <div class="item_info">
                                                    <div class="item_info_c1">高级及以上</div>
                                                    <div class="item_info_c2">{{teaData.gjRankTeacherRate}}%</div>
                                                </div>
                                            </div>
                                            <div class="item_01">
                                                <div class="item_color2"></div>
                                                <div class="item_info">
                                                    <div class="item_info_c1">一级教师</div>
                                                    <div class="item_info_c2">{{teaData.yjRankTeacherRate}}%</div>
                                                </div>
                                            </div>
                                            <div class="item_01">
                                                <div class="item_color3"></div>
                                                <div class="item_info">
                                                    <div class="item_info_c1">二级及其他</div>
                                                    <div class="item_info_c2">{{teaData.ejRankTeacherRate}}%</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tea-subject-container">
                        <div class="data-title-container">
                            <div class="title-container1"></div>
                            <div class="title-container2">教师学科分布概况</div>
                            <div class="title-container3">{{timestampDate(currentTime)}}更新</div>
                        </div>
                        <div class="tea-subject-echart-container">
                            <div class="tea-subject-echart-item-container1" v-loading="loading3">
                                <div class="data-dashboard-title-container">
                                    <div class="data-dashboard-title">
                                        <div class="data-title">教师学科分布</div>
                                        <div :class="period2==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'1')">小学</div>
                                        <div :class="period2==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'2')">初中</div>
                                        <div :class="period2==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'3')">高中</div>
                                    </div>
                                </div>
                                <area-tea-subject-echart :count-list="teaSubject.countList" :item-list="teaSubject.itemList" />
                            </div>
                            <div class="tea-subject-echart-item-container2" v-loading="loading4">
                                <div class="data-dashboard-title-container">
                                    <div class="data-dashboard-title">
                                        <div class="data-title">学科新老教师分布</div>
                                        <div :class="period3==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'1')">小学</div>
                                        <div :class="period3==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'2')">初中</div>
                                        <div :class="period3==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'3')">高中</div>
                                    </div>
                                </div>
                                <area-tea-work-age-subject-echart :one-count-list="teaTeachAgeSubject.oneCountList"
                                                                  :two-count-list="teaTeachAgeSubject.twoCountList"
                                                                  :three-count-list="teaTeachAgeSubject.threeCountList"
                                                                  :four-count-list="teaTeachAgeSubject.fourCountList"
                                                                  :item-list="teaTeachAgeSubject.itemList" />
                                <div class="echarts-color-item-container">
                                    <div class="echarts-color1"></div>
                                    <div class="echarts-color-title">教龄1-5年</div>
                                    <div class="echarts-color2"></div>
                                    <div class="echarts-color-title">教龄5-10年</div>
                                    <div class="echarts-color3"></div>
                                    <div class="echarts-color-title">教龄10年以上</div>
                                    <div class="echarts-color4"></div>
                                    <div class="echarts-color-title">其他</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item1-r-content-container-auto">
                    <div class="data-title-container">
                        <div class="title-container1"></div>
                        <div class="title-container2">学校概况</div>
                        <div class="title-container3">{{timestampDate(currentTime)}}更新</div>
                    </div>
                    <div class="tea-data-info-container">
                        <div class="school-data-item">
                            <div class="tea-data-item-child1">{{schoolData.schoolCount}}</div>
                            <div class="tea-data-item-child2">学校数量</div>
                        </div>
                        <div class="school-data-item">
                            <div class="tea-data-item-child1">{{schoolData.xxSchoolCount}}</div>
                            <div class="tea-data-item-child2">小学</div>
                        </div>
                        <div class="school-data-item">
                            <div class="tea-data-item-child1">{{schoolData.czSchoolCount}}</div>
                            <div class="tea-data-item-child2">初中</div>
                        </div>
                        <div class="school-data-item">
                            <div class="tea-data-item-child1">{{schoolData.gzSchoolCount}}</div>
                            <div class="tea-data-item-child2">高中</div>
                        </div>
                    </div>
                    <div class="item1-r-echarts-mt-container1" v-loading="loading6">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">学校学段分布</div>
                            </div>
                        </div>
                        <area-school-echart  :age1-count="schoolData.xxSchoolCount"
                                             :age2-count="schoolData.czSchoolCount"
                                             :age3-count="schoolData.gzSchoolCount"/>
                    </div>
                    <div class="data-title-container">
                        <div class="title-container1"></div>
                        <div class="title-container2">教师年龄、教龄分布概况</div>
                    </div>
                    <div class="item1-r-echarts-mt-container1" v-loading="loading2">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">教师年龄结构分布</div>
                                <div :class="period1==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'1')">小学</div>
                                <div :class="period1==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'2')">初中</div>
                                <div :class="period1==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'3')">高中</div>
                            </div>
                        </div>
                        <area-tea-age-echart  :age1-count="teaAge.age1Count"
                                              :age2-count="teaAge.age2Count"
                                              :age3-count="teaAge.age3Count"
                                              :age4-count="teaAge.age4Count"
                                              :age5-count="teaAge.age5Count"
                                              :age6-count="teaAge.age6Count"/>
                    </div>
                    <div class="item1-r-echarts-container2" v-loading="loading5">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">教师教龄结构分布</div>
                                <div :class="period4==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'1')">小学</div>
                                <div :class="period4==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'2')">初中</div>
                                <div :class="period4==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'3')">高中</div>
                            </div>
                        </div>
                        <area-tea-work-age-echart :count-list="teaWorkAge.countList" :item-list="teaWorkAge.itemList"/>
                    </div>
                </div>
            </div>

            <!-- 数据看板-课堂研究驾驶舱 -->
            <div class="dashboard-container" v-if="activeItem==='2'">
                <div class="item1-l-content-container">
                    <div class="eva-data-container">
                        <div class="data-title-container">
                            <div class="title-container1"></div>
                            <div class="title-container2">课堂研究概况</div>
                            <div class="title-container3">{{timestampDate(currentTime)}}更新</div>
                        </div>
                        <div class="eva-data-info-container" v-loading="loading7">
                            <div class="eva-data-item">
                                <div class="eva-data-item-child1">{{evaData.evaCount}}</div>
                                <div class="eva-data-item-child2">听课总节数</div>
                            </div>
                            <div class="eva-data-item">
                                <div class="eva-data-item-child1">{{evaData.evaPeopleCount}}</div>
                                <div class="eva-data-item-child2">听课总人次</div>
                            </div>
                            <div class="eva-data-item">
                                <div class="eva-data-item-child1">{{evaData.evaTeacherCount}}</div>
                                <div class="eva-data-item-child2">听课教师数</div>
                            </div>
                            <div class="eva-data-item">
                                <div class="eva-data-item-child1">{{evaData.evaCount-evaData.onlineEvaCount}}</div>
                                <div class="eva-data-item-child2">推门听课数</div>
                            </div>
                            <div class="eva-data-item">
                                <div class="eva-data-item-child1">{{evaData.onlineEvaCount}}</div>
                                <div class="eva-data-item-child2">在线听课数</div>
                            </div>
                        </div>
                    </div>

                    <div class="eva-echarts-container">
                        <div class="data-title-container">
                            <div class="title-container1"></div>
                            <div class="title-container2">课堂分布概况</div>
                            <div class="title-container3">{{timestampDate(currentTime)}}更新</div>
                        </div>
                        <div class="eva-echarts-container1">
                            <div class="eva-echarts-container-child1" v-loading="loading1">
                                <div class="data-dashboard-title-container">
                                    <div class="data-dashboard-title">
                                        <div class="data-title">听评课学科分布</div>
                                        <div :class="period1==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'1')">小学</div>
                                        <div :class="period1==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'2')">初中</div>
                                        <div :class="period1==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'3')">高中</div>
                                    </div>
                                </div>
                                <area-eva-subject-echart :item-list="evaSubjectData.subjectList" :count-list="evaSubjectData.countList"/>

                            </div>
                            <div class="eva-echarts-container-child2" v-loading="loading2">
                                <div class="data-dashboard-title-container">
                                    <div class="data-dashboard-title">
                                        <div class="data-title">听评课人数分布</div>
                                        <div :class="period2==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'1')">小学</div>
                                        <div :class="period2==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'2')">初中</div>
                                        <div :class="period2==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'3')">高中</div>
                                    </div>
                                </div>
                                <area-eva-people-num-echart :item-list="evaNumData.subjectList" :count-list="evaNumData.countList" />
                            </div>
                        </div>
                        <div class="eva-echarts-container2">
                            <div class="eva-echarts-container-child1" v-loading="loading4">
                                <div class="data-dashboard-title-container">
                                    <div class="data-dashboard-title">
                                        <div class="data-title">听评课时间分布</div>
                                        <div :class="period4==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'1')">小学</div>
                                        <div :class="period4==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'2')">初中</div>
                                        <div :class="period4==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'3')">高中</div>
                                    </div>
                                </div>
                                <area-eva-year-time-echart :month-list="evaYearData.monthList"
                                                           :one-count-list="evaYearData.oneCountList"
                                                           :two-count-list="evaYearData.twoCountList"
                                                           :three-count-list="evaYearData.threeCountList" />
                            </div>
                            <div class="eva-echarts-container-child2" v-loading="loading5">
                                <div class="data-dashboard-title-container">
                                    <div class="data-dashboard-title">
                                        <div class="data-title">听评课学科教龄分布</div>
                                        <div :class="period5==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(5,'1')">小学</div>
                                        <div :class="period5==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(5,'2')">初中</div>
                                        <div :class="period5==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(5,'3')">高中</div>
                                    </div>
                                </div>
                                <area-eva-age-subject-echart :one-count-list="evaTeachAgeData.oneCountList"
                                                             :two-count-list="evaTeachAgeData.twoCountList"
                                                             :three-count-list="evaTeachAgeData.threeCountList"
                                                             :four-count-list="evaTeachAgeData.fourCountList"
                                                             :item-list="evaTeachAgeData.itemList"/>
                                <div class="echarts-color-item-container" style="margin-top: -10px!important;">
                                    <div class="echarts-color1"></div>
                                    <div class="echarts-color-title">教龄1-5年</div>
                                    <div class="echarts-color2"></div>
                                    <div class="echarts-color-title">教龄5-10年</div>
                                    <div class="echarts-color3"></div>
                                    <div class="echarts-color-title">教龄10年以上</div>
                                    <div class="echarts-color4"></div>
                                    <div class="echarts-color-title">其他</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="item1-r-content-container">
                    <div class="item1-r-title-container">注册教师数量：{{evaData.teaCount}}</div>
                    <div class="item1-r-echarts-container1" v-loading="loading3">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">各年龄段人均听课分布</div>
                                <div :class="period3==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'1')">小学</div>
                                <div :class="period3==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'2')">初中</div>
                                <div :class="period3==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'3')">高中</div>
                            </div>
                        </div>
                        <area-eva-age-echart :age1-count="evaAgeData.age1Count"
                                             :age2-count="evaAgeData.age2Count"
                                             :age3-count="evaAgeData.age3Count"
                                             :age4-count="evaAgeData.age4Count"
                                             :age5-count="evaAgeData.age5Count"
                                             :age6-count="evaAgeData.age6Count"/>
                    </div>
                    <div class="item1-r-echarts-container2" v-loading="loading6">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">听评课方式分布</div>
                                <div :class="period6==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(6,'1')">小学</div>
                                <div :class="period6==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(6,'2')">初中</div>
                                <div :class="period6==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(6,'3')">高中</div>
                            </div>
                        </div>
                        <area-eva-type-echart :count1="evaTypeData.tmEvaCount" :count2="evaTypeData.lbEvaCount" :count3="evaTypeData.zbEvaCount"/>
                    </div>
                </div>
            </div>

            <!-- 数据看板-教研资产管理 -->
            <div class="dashboard-container" v-if="activeItem==='3'">

            </div>

        </div>
    </div>
</template>

<script>

import {timestampDate} from "@/utils/date";
import {ElLoading} from "element-plus";
import {listUserManagerOrgNew} from "@/api/admin/system";
import {
    areaSchoolData,
    areaTeacherData,
    areaTeacherAge,
    areaTeacherSubject,
    areaTeacherAgeSubject,
    areaTeacherTeachAge,
    areaEvaData,
    areaEvaSubject,
    areaEvaNumData,
    areaEvaAgeData,
    areaEvaYearData,
    areaEvaTeachAgeData,
    areaEvaTypeData
} from "@/api/admin/areaDashboard"

import areaTeaXbEchart from "@/components/areaDashboard/tea/areaTeaXbEchart.vue";
import areaTeaXlEchart from "@/components/areaDashboard/tea/areaTeaXlEchart.vue";
import areaTeaZcEchart from "@/components/areaDashboard/tea/areaTeaZcEchart.vue";
import areaTeaAgeEchart from "@/components/areaDashboard/tea/areaTeaAgeEchart.vue";
import areaTeaSubjectEchart from "@/components/areaDashboard/tea/areaTeaSubjectEchart.vue";
import areaTeaWorkAgeSubjectEchart from "@/components/areaDashboard/tea/areaTeaWorkAgeSubjectEchart.vue";
import areaTeaWorkAgeEchart from "@/components/areaDashboard/tea/areaTeaWorkAgeEchart.vue";

import areaEvaSubjectEchart from "@/components/areaDashboard/eva/areaEvaSubjectEchart.vue";
import areaEvaPeopleNumEchart from "@/components/areaDashboard/eva/areaEvaPeopleNumEchart.vue";
import areaEvaAgeEchart from "@/components/areaDashboard/eva/areaEvaAgeEchart.vue";
import areaEvaYearTimeEchart from "@/components/areaDashboard/eva/areaEvaYearTimeEchart.vue";
import areaEvaAgeSubjectEchart from "@/components/areaDashboard/eva/areaEvaAgeSubjectEchart.vue";
import areaEvaTypeEchart from "@/components/areaDashboard/eva/areaEvaTypeEchart.vue";
import areaSchoolEchart from "@/components/areaDashboard/tea/areaSchoolEchart.vue";
export default {
    name: "areaDashboard",
    components: {
        areaTeaXbEchart,areaTeaXlEchart,areaTeaZcEchart,areaTeaAgeEchart,
        areaTeaSubjectEchart,areaTeaWorkAgeSubjectEchart,areaTeaWorkAgeEchart,
        areaEvaSubjectEchart,areaEvaPeopleNumEchart,areaEvaAgeEchart,
        areaEvaYearTimeEchart,areaEvaAgeSubjectEchart,areaEvaTypeEchart,areaSchoolEchart
    },
    data() {
        return {
            loading1: false,
            loading2: false,
            loading3: false,
            loading4: false,
            loading5: false,
            loading6: false,
            loading7: false,
            period1:'',
            period2:'',
            period3:'',
            period4:'',
            period5:'',
            period6:'',
            timestampDate,
            currentTime:new Date().getTime(),
            activeItem:"1",
            itemName:"教师均衡发展驾驶舱",
            userInfo : JSON.parse(this.$storage.get("userInfo")),
            orgList:[],
            orgInfo:{},
            orgId:'',
            // 教师发展均衡驾驶舱数据
            queryTeaForm:{
                orgId:'',
                period:''
            },
            teaData:{},
            schoolData:{},
            teaAge:{},
            teaSubject:{},
            teaTeachAgeSubject:{},
            teaWorkAge:{},
            // 课堂研究
            queryEvaForm:{
                orgId:'',
                period:'',
                yearCode:''
            },
            evaData:{},
            evaSubjectData:{},
            evaNumData:{},
            evaAgeData:{},
            evaYearData:{},
            evaTeachAgeData:{},
            evaTypeData:{},

        };
    },
    created() {
        this.getOrgList();
    },
    mounted() {},
    activated() {},
    computed:{
        timestamp(){
            return new Date().getTime();
        }
    },
    methods: {
        changeItem(item){
            this.activeItem = item;
            this.period1 = '';
            this.period2 = '';
            this.period3 = '';
            this.period4 = '';
            this.period5 = '';
            this.period6 = '';
            this.loading1 = false;
            this.loading2 = false;
            this.loading3 = false;
            this.loading4 = false;
            this.loading5 = false;
            this.loading6 = false;
            this.loading7 = false;
            this.queryTeaForm.period = '';
            this.queryEvaForm.period = '';
            if (item==='1'){
                this.itemName = '教师均衡发展驾驶舱';
                this.queryAreaSchoolData();
                this.queryAreaTeacherData();
                this.queryAreaTeacherAge();
                this.queryAreaTeacherSubject();
                this.queryAreaTeacherAgeSubject();
                this.queryAreaTeacherWorkAge();
            }
            if (item==='2'){
                this.itemName = '课堂研究驾驶舱';
                this.queryAreaEvaData();
                this.queryAreaEvaSubjectData();
                this.queryAreaEvaPeopleNumData();
                this.queryAreaEvaAgeData();
                this.queryAreaEvaYearData();
                this.queryAreaEvaTeachAgeData();
                this.queryAreaEvaTypeData();
            }
            if (item==='3'){
                this.itemName = '教研资产管理';
            }

        },
        getOrgList() {
            const loading = ElLoading.service({ fullscreen: true })
            listUserManagerOrgNew().then(res => {
                if (res.data.code === 1){
                    this.orgList = res.data.data;
                    this.orgInfo = this.orgList[0];
                    this.orgId = this.orgInfo.orgId;
                    this.queryTeaForm.orgId = this.orgInfo.orgId;
                    this.queryEvaForm.orgId = this.orgInfo.orgId;
                    if (this.activeItem==='1'){
                        this.queryAreaSchoolData();
                        this.queryAreaTeacherData();
                        this.queryAreaTeacherAge();
                        this.queryAreaTeacherSubject();
                        this.queryAreaTeacherAgeSubject();
                        this.queryAreaTeacherWorkAge();
                    }
                    if (this.activeItem==='2'){
                        this.queryAreaEvaData();
                        this.queryAreaEvaSubjectData();
                        this.queryAreaEvaPeopleNumData();
                        this.queryAreaEvaAgeData();
                        this.queryAreaEvaYearData();
                        this.queryAreaEvaTeachAgeData();
                        this.queryAreaEvaTypeData();
                    }
                    loading.close()
                }else {
                    this.$message.error("服务异常")
                    loading.close()
                }
            })
        },
        orgChange(item){
            this.orgList.forEach(e => {
                if (e.orgId===item){
                    this.orgId=item;
                    this.orgInfo=e;
                    this.queryTeaForm.orgId = this.orgInfo.orgId;
                    this.queryTeaForm.period = "";
                    this.queryEvaForm.orgId = this.orgInfo.orgId;
                    this.queryEvaForm.period = '';
                    this.period1 = '';
                    this.period2 = '';
                    this.period3 = '';
                    this.period4 = '';
                    this.period5 = '';
                    this.period6 = '';
                    if (this.activeItem==='1'){
                        this.queryAreaSchoolData();
                        this.queryAreaTeacherData();
                        this.queryAreaTeacherAge();
                        this.queryAreaTeacherSubject();
                        this.queryAreaTeacherAgeSubject();
                        this.queryAreaTeacherWorkAge();
                    }
                    if (this.activeItem==='2'){
                        this.queryAreaEvaData();
                        this.queryAreaEvaSubjectData();
                        this.queryAreaEvaPeopleNumData();
                        this.queryAreaEvaAgeData();
                        this.queryAreaEvaYearData();
                        this.queryAreaEvaTeachAgeData();
                        this.queryAreaEvaTypeData();
                    }
                }
            })
        },
        /*========学段切换========*/
        changePeriod(num,periodKey){
            // 教师发展
            if (this.activeItem==='1'){
                if (num === 1){
                    this.period1 = periodKey;
                    this.queryTeaForm.period = periodKey;
                    this.queryAreaTeacherAge();
                }
                if (num === 2){
                    this.period2 = periodKey;
                    this.queryTeaForm.period = periodKey;
                    this.queryAreaTeacherSubject();
                }
                if (num === 3){
                    this.period3 = periodKey;
                    this.queryTeaForm.period = periodKey;
                    this.queryAreaTeacherAgeSubject();
                }
                if (num === 4){
                    this.period4 = periodKey;
                    this.queryTeaForm.period = periodKey;
                    this.queryAreaTeacherWorkAge();
                }
            }
            // 听评课
            if (this.activeItem==='2'){
                if (num === 1){
                    this.period1 = periodKey;
                    this.queryEvaForm.period = periodKey;
                    this.queryAreaEvaSubjectData();
                }
                if (num === 2){
                    this.period2 = periodKey;
                    this.queryEvaForm.period = periodKey;
                    this.queryAreaEvaPeopleNumData();
                }
                if (num === 3){
                    this.period3 = periodKey;
                    this.queryEvaForm.period = periodKey;
                    this.queryAreaEvaAgeData();
                }
                if (num === 4){
                    this.period4 = periodKey;
                    this.queryEvaForm.period = periodKey;
                    this.queryAreaEvaYearData()
                }
                if (num === 5){
                    this.period5 = periodKey;
                    this.queryEvaForm.period = periodKey;
                    this.queryAreaEvaTeachAgeData();
                }
                if (num === 6){
                    this.period6 = periodKey;
                    this.queryEvaForm.period = periodKey;
                    this.queryAreaEvaTypeData();
                }
            }

        },
        /*教师均衡发展驾驶舱*/
        queryAreaSchoolData(){
            this.loading6 = true;
            areaSchoolData({orgId:this.orgId}).then(res => {
                if (res.data.code === 1){
                    this.schoolData = res.data.data;
                    this.loading6 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading6 = false;
                }
            })
        },
        queryAreaTeacherData(){
            this.loading1 = true;
            areaTeacherData({orgId:this.orgId}).then(res => {
                if (res.data.code === 1){
                    this.teaData = res.data.data;
                    this.loading1 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading1 = false;
                }
            })
        },
        queryAreaTeacherAge(){
            this.loading2 = true;
            areaTeacherAge(this.queryTeaForm).then(res => {
                if (res.data.code === 1){
                    this.teaAge = res.data.data;
                    this.loading2 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading2 = false;
                }
            })
        },
        queryAreaTeacherSubject(){
            this.loading3 = true;
            areaTeacherSubject(this.queryTeaForm).then(res => {
                if (res.data.code === 1){
                    this.teaSubject = res.data.data;
                    this.loading3 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading3 = false;
                }
            })
        },
        queryAreaTeacherAgeSubject(){
            this.loading4 = true;
            areaTeacherAgeSubject(this.queryTeaForm).then(res => {
                if (res.data.code === 1){
                    this.teaTeachAgeSubject = res.data.data;
                    this.loading4 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading4 = false;
                }
            })
        },
        queryAreaTeacherWorkAge(){
            this.loading5 = true;
            areaTeacherTeachAge(this.queryTeaForm).then(res => {
                if (res.data.code === 1){
                    this.teaWorkAge = res.data.data;
                    this.loading5 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading5 = false;
                }
            })
        },
        /*课堂研究*/
        queryAreaEvaData(){
            this.loading7 = true;
            areaEvaData({orgId:this.orgId}).then(res => {
                if (res.data.code === 1){
                    this.evaData = res.data.data;
                    this.loading7 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading7 = false;
                }
            })
        },
        queryAreaEvaSubjectData(){
            this.loading1 = true;
            areaEvaSubject(this.queryEvaForm).then(res => {
                if (res.data.code === 1){
                    this.evaSubjectData = res.data.data;
                    this.loading1 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading1 = false;
                }
            })
        },
        queryAreaEvaPeopleNumData(){
            this.loading2 = true;
            areaEvaNumData(this.queryEvaForm).then(res => {
                if (res.data.code === 1){
                    this.evaNumData = res.data.data;
                    this.loading2 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading2 = false;
                }
            })
        },
        queryAreaEvaAgeData(){
            this.loading3 = true;
            areaEvaAgeData(this.queryEvaForm).then(res => {
                if (res.data.code === 1){
                    this.evaAgeData = res.data.data;
                    this.loading3 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading3 = false;
                }
            })
        },
        queryAreaEvaYearData(){
            this.loading4 = true;
            areaEvaYearData(this.queryEvaForm).then(res => {
                if (res.data.code === 1){
                    this.evaYearData = res.data.data;
                    this.loading4 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading4 = false;
                }
            })
        },
        queryAreaEvaTeachAgeData(){
            this.loading5 = true;
            areaEvaTeachAgeData(this.queryEvaForm).then(res => {
                if (res.data.code === 1){
                    this.evaTeachAgeData = res.data.data;
                    this.loading5 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading5 = false;
                }
            })
        },
        queryAreaEvaTypeData(){
            this.loading6 = true;
            areaEvaTypeData(this.queryEvaForm).then(res => {
                if (res.data.code === 1){
                    this.evaTypeData = res.data.data;
                    this.loading6 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading6 = false;
                }
            })
        },
    }
};
</script>
<style scoped>
.stat-container{
    width: 100%;
    height: 100vh;
    display: flex;
    background: #1f5bdf;
    font-family: 'SourceHanSansSC', sans-serif;
}
/*左栏*/
.l-stat-container{
    width: 200px;
    height: 100vh;
    background-color: #dfe4f7;
}
.org-container{
    width: 100%;
    height: 140px;
    padding: 15px 5px 0 5px;
    box-sizing: border-box;
}
.org-logo-container{
    width: 60px;
    height: 60px;
    border-radius: 30px;
    margin: auto;
}
.org-logo{
    width: 60px;
    height: 60px;
    border-radius: 30px;
}
.school-name-container{
    width: 100%;
    height: 24px;
    line-height: 24px;
    text-align: center;
    color: #1f5bdf;
    font-size: 16px;
    font-weight: bold;
    font-family: sans-serif;
}
.org-name-container{
    width: 100%;
    height: 20px;
    text-align: center;
    color: #121212;
    font-size: 12px;
    font-weight: bold;
    font-family: sans-serif;
}
.menu-container{
    width: 100%;
    height: calc(100vh - 160px);
    background: #dfe4f7;
    padding-bottom: 15px;
    border-radius: 10px;
}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 15px;
    font-size: 15px;
    color: #707070;
    cursor: pointer;
}
.menu-active{
    background: #1f5bdf;
    color: #fff;
    //font-weight: bold;
}
/*右栏*/
.r-stat-container{
    width: calc(100% - 215px);
    height: 100vh;
    margin-left: 10px;
}
.school-info-container{
    width: 100%;
    height: 70px;
    margin-top: 5px;
    display: flex;
    border-radius: 8px;
}
.l-school-info-container{
    width: 160px;
    height: 80px;
    margin-bottom: 10px;
}
.r-school-info-container{
    width: calc(100% - 320px);
    height: 80px;
    margin-bottom: 10px;
}
.r-school-info-container-child1{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    font-family: sans-serif;
}
.r-school-info-container-child2{
    width: 100%;
    height: 30px;
    text-align: center;
    color: #ffbf6b;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
}
/*看板数据*/
.dashboard-container{
    width: 100%;
    height: calc(100vh - 80px);
    display: flex;
}
.dashboard-container-auto{
    width: 100%;
    height: calc(100vh - 80px);
    display: flex;
    padding-bottom: 5px;
}
/*教师均衡发展*/
.item1-l-content-container{
    width: 72%;
    height: 100%;
    padding: 0 10px 0 0;

}
/*统一标题模块*/
.data-title-container{
    width: 100%;
    height: 30px;
    display: flex;
    padding: 10px 0 0 10px;
    box-sizing: border-box;
}
.title-container1{
    width: 5px;
    height: 100%;
    background-color: #56e6f1;
}
.title-container2{
    width: auto;
    height: 20px;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    padding-left: 8px;
    line-height: 20px;
}
.title-container3{
    width: auto;
    height: 20px;
    color: #fff;
    font-size: 13px;
    padding-left: 20px;
    line-height: 24px;
}
/*图表标题*/
.data-dashboard-title-container{
    width: 100%;
    height: 30px;
    display: flex;
}
.data-dashboard-title{
    width: 100%;
    height: 30px;
    display: flex;
}
.data-title{
    width: calc(100% - 120px);
    height: 30px;
    padding: 0 15px 0 10px;
    line-height: 30px;
    color: #fff;
    text-align: left;
    font-weight: bold;
    font-size: 14px;
}
.data-title-small{
    width: calc(100% - 120px);
    height: 30px;
    padding: 0 15px 0 10px;
    line-height: 30px;
    color: #fff;
    text-align: left;
    font-weight: bold;
    font-size: 12px;
}
.data-item{
    width: 25px;
    height: 18px;
    line-height: 18px;
    padding: 0 3px 0 3px;
    margin-top: 5px;
    margin-right: 3px;
    color: #101010;
    text-align: center;
    font-size: 10px;
    border: 1px solid #fff;
    background-color: #fff;
    border-radius: 5px;
    cursor: pointer;
    z-index: 99;
    float: right;
}
.data-item-active{
    color: #fff;
    background-color: #68bbc4;
    text-align: center;
    font-size: 10px;
    border: 1px solid #68bbc4;
}
/*=====================教师均衡发展=====================*/
.tea-data-container{
    width: 100%;
    height: calc(50vh - 45px);
    background-color: #2076ff;
    border-radius: 5px;
}
.tea-data-info-container{
    width: 100%;
    height: 80px;
    display: flex;
}
.school-data-item{
    width: 25%;
    height: 70px;
}
.tea-data-item{
    width: 16.6%;
    height: 70px;
}
.tea-data-item-child1{
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 60px;
    font-size: 22px;
    font-weight: bold;
    color: #fff;
}
.tea-data-item-child2{
    width: 100%;
    height: 20px;
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    color: #fff;
}
.tea-echart-container{
    width: 98%;
    height: calc(50vh - 150px);
    border-radius: 5px;
    margin: auto;
    display: flex;
}
.tea-echart-item-container1{
    width: 32.66%;
    height: calc(50vh - 160px);
    margin-right: 1%;
    background-color: #1f5bdf;
    border-radius: 6px;
}
.tea-echart-item-container2{
    width: 32.66%;
    height: calc(50vh - 160px);
    background-color: #1f5bdf;
    border-radius: 6px;

}
/*教师概况图表区域*/
.tea-echart-item{
    width: 100%;
    height: calc(50vh - 190px);
    display: flex;
}
.tea-echart-item-l{
    width: 55%;
    height: calc(50vh - 190px);
    display: flex;
}
.tea-echart-item-r{
    width: 45%;
    height: calc(50vh - 190px);
}
.item_container1{
    width: 100%;
    height: calc(50vh - 190px);
    margin-top: calc(8vh - 30px);
}
.item_container2{
    width: 100%;
    height: calc(50vh - 190px);
}
.item_01{
    width: 100%;
    height: 33.3%;
    padding-left: 10px;
    padding-bottom: 5px;
    box-sizing: border-box;
    display: flex;
    color: #fff;
}
.item_color1{
    width: 4px;
    height: 90%;
    background-color: #ed6616;
}
.item_color2{
    width: 4px;
    height: 90%;
    background-color: #f39423;
}
.item_color3{
    width: 4px;
    height: 90%;
    background-color: #f9c78b;
}
.item_info{
    width: calc(100% - 5px);
    height: 100%;
}
.item_info_c1{
    width: 100%;
    height: 50%;
    font-size: 14px;
    text-indent: 6px;
}
.item_info_c2{
    width: 100%;
    height: 50%;
    font-size: clamp(14px, 1vw, 20px);
    text-indent: 6px;
}
/*教师学科分布*/
.tea-subject-container{
    width: 100%;
    height: calc(50vh - 45px);
    margin-top: 10px;
    background-color: #2076ff;
    border-radius: 5px;
}
.tea-subject-echart-container{
    width: 98%;
    height: calc(50vh - 80px);
    border-radius: 5px;
    margin: auto;
    display: flex;
    padding-top: 10px;
    box-sizing: border-box;
}
.tea-subject-echart-item-container1{
    width: 49.5%;
    height: calc(50vh - 90px);
    margin-right: 1%;
    background-color: #1f5bdf;
    border-radius: 6px;
}
.tea-subject-echart-item-container2{
    width: 49.5%;
    height: calc(50vh - 90px);
    background-color: #1f5bdf;
    border-radius: 6px;
}
.echarts-color-item-container{
    width: 100%;
    height: 30px;
    z-index: 999;
    margin: auto;
    padding-top: 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
}
.echarts-color1{
    width: 15px;
    height: 10px;
    background-color: #68bbc4;
    border-radius: 2px;
    margin-right: 3px;
    margin-top: 2px;
}
.echarts-color2{
    width: 15px;
    height: 10px;
    background-color: #5087ec;
    border-radius: 2px;
    margin-right: 3px;
    margin-top: 2px;
}
.echarts-color3{
    width: 15px;
    height: 10px;
    background-color: #ffbf6b;
    border-radius: 2px;
    margin-right: 3px;
    margin-top: 2px;
}
.echarts-color4{
    width: 15px;
    height: 10px;
    background-color: #3ba272;
    border-radius: 2px;
    margin-right: 3px;
    margin-top: 2px;
}
.echarts-color-title{
    width: auto;
    height: 30px;
    line-height: 30px;
    font-size: 10px;
    color: #fff;
    padding: 0 2px 0 0;
}
/*右侧图表 100vh - 80px*/
.item1-r-content-container{
    width: calc(28% - 10px);
    height: 100%;
    background-color: #2076ff;
    border-radius: 5px;
}
.item1-r-title-container{
    width: 100%;
    height: 40px;
    line-height: 40px;
    color: #fff;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
}
.item1-r-echarts-container1{
    width: 96%;
    height: calc(50vh - 65px);
    background-color: #1f5bdf;
    border-radius: 6px;
    margin: auto;
}
.item1-r-echarts-container2{
    width: 96%;
    height: calc(50vh - 65px);
    background-color: #1f5bdf;
    border-radius: 6px;
    margin: auto;
    margin-top: 5px;
}

.item1-r-echarts-mt-container1{
    width: 96%;
    height: calc(50vh - 65px);
    background-color: #1f5bdf;
    border-radius: 6px;
    margin: auto;
    margin-top: 10px;
}
.item1-r-content-container-auto{
    width: calc(28% - 10px);
    height: calc(100vh - 80px);
    background-color: #2076ff;
    border-radius: 5px;
    padding-bottom: 5px;
    box-sizing: border-box;
    overflow-x: auto;
}


/*===================课堂研究=====================*/
.eva-data-container{
    width: 100%;
    height: 120px;
    background-color: #2076ff;
    border-radius: 5px;
}
.eva-data-info-container{
    width: 100%;
    height: 80px;
    display: flex;
}
.eva-data-item{
    width: 20%;
    height: 70px;
}
.eva-data-item-child1{
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 60px;
    font-size: 22px;
    font-weight: bold;
    color: #fff;
}
.eva-data-item-child2{
    width: 100%;
    height: 20px;
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    color: #fff;
}

.eva-echarts-container{
    width: 100%;
    height: calc(100vh - 210px);
    margin-top: 10px;
    background-color: #2076ff;
    border-radius: 5px;
}
.eva-echarts-container1{
    width: 98%;
    height: calc(50vh - 130px);
    padding-top: 5px;
    margin: auto;
    display: flex;
}
.eva-echarts-container2{
    width: 98%;
    height: calc(50vh - 130px);
    padding-top: 10px;
    margin: auto;
    display: flex;
}
.eva-echarts-container-child1{
    width: 49.5%;
    height: calc(50vh - 130px);
    background-color: #1f5bdf;
    margin-right: 1%;
    border-radius: 6px;
}
.eva-echarts-container-child2{
    width: 49.5%;
    height: calc(50vh - 130px);
    background-color: #1f5bdf;
    border-radius: 6px;
}
</style>
